import connection from './connection.js'

const list = async function (callback) {
  const url = '/admin/category/list'
  let {
    error,
    data
  } = await connection.query(url)
  if (callback) callback(error, data)
}

const create = async function (params, callback) {
  const url = '/admin/category/create'
  let {
    error,
    data
  } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const update = async function (params, callback) {
  const url = '/admin/category/update'
  let {
    error,
    data
  } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const updateStatus = async function (id, status, callback) {
  const url = '/admin/category/update/status'
  let {
    error,
    data
  } = await connection.update(url, {
    id: id,
    status: status
  })
  if (callback) callback(error, data)
}

const addSub = async function (params, callback) {
  const url = '/admin/category/add/sub'
  let {
    error,
    data
  } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const editSub = async function (params, callback) {
  const url = '/admin/category/edit/sub'
  let {
    error,
    data
  } = await connection.update(url, params)
  if (callback) callback(error, data)
}

const delSub = async function (subId, callback) {
  const url = '/admin/category/del/sub'
  let {
    error,
    data
  } = await connection.update(url, {
    subId: subId
  })
  if (callback) callback(error, data)
}


export default {
  list: list,
  create: create,
  update: update,
  updateStatus: updateStatus,
  addSub: addSub,
  editSub: editSub,
  delSub: delSub
}